/* eslint-disable */
const md5 = require("js-md5");
function jsonp(url, callback) {
  if (!url) throw new Error("url is necessary");

  const JSONP = document.createElement("script");
  JSONP.setAttribute("type", "text/javascript");

  const headEle = document.getElementsByTagName("head")[0];

  JSONP.src = `${url}`;
  return new Promise((resolve, reject) => {
    window[callback] = (r) => {
      resolve(r);
      headEle.removeChild(JSONP);
      delete window[callback];
    };
    headEle.appendChild(JSONP);
  });
}

const qqMapKey = "PL7BZ-QDQRP-X4GDK-VS632-IXOE6-JQFZS";
const qqMapSig = "NA3eRGV0HRPa4R9TTVe2fJaZ3fNG2jcK";
export const qqmap_getCurrentPosition = function () {
  const callback = "CALLBACK" + Math.random().toString().substr(9, 18);
  const query_data = `callback=${callback}&key=${qqMapKey}&output=jsonp`;
  const api = `/ws/location/v1/ip`;
  const sig = md5(`${api}?${query_data}${qqMapSig}`);
  return jsonp(`https://apis.map.qq.com${api}?${query_data}&sig=${sig}`, callback);
};

export const qqmap_reverseGeocoder = function (location) {
  const callback = "CALLBACK" + Math.random().toString().substr(9, 18);
  const query_data = `callback=${callback}&get_poi=1&key=${qqMapKey}&location=${location}&output=jsonp`;
  const sig = md5(`/ws/geocoder/v1?${query_data}${qqMapSig}`);
  const api = `/ws/geocoder/v1`;
  return jsonp(`https://apis.map.qq.com${api}?${query_data}&sig=${sig}`, callback);
};

// 腾讯地图-地点搜索
export const qqmap_search = function (data) {
  const callback = "CALLBACK" + Math.random().toString().substr(9, 18);
  const default_data = {
    boundary: `region(佛山市,0)`,
    key: qqMapKey,
    keyword: "",
    page_index: 1,
    page_size: 10,
  };
  const post_data = Object.assign(default_data, data);
  const query_data = `boundary=${post_data.boundary}&callback=${callback}&key=${post_data.key}&keyword=${post_data.keyword}&output=jsonp&page_index=${post_data.page_index}&page_size=${post_data.page_size}`;
  const sig = md5(`/ws/place/v1/search?${query_data}${qqMapSig}`);
  const api = `/ws/place/v1/search`;
  return jsonp(`https://apis.map.qq.com${api}?${query_data}&sig=${sig}`, callback);
};
